export const INACTIVITY_MINUTES_TO_LOGOUT = 15;
